import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageHotelMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
  packageHotelInput: GraphQLTypes.UpdateHotelPackageInput;
}>;


export type UpdatePackageHotelMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackageHotel'>
);


export const UpdatePackageHotelDocument = /*#__PURE__*/ gql`
    mutation updatePackageHotel($packageId: String!, $id: String!, $packageHotelInput: UpdateHotelPackageInput!) {
  updatePackageHotel(
    packageId: $packageId
    id: $id
    packageHotelInput: $packageHotelInput
  )
}
    `;

/**
 * __useUpdatePackageHotelMutation__
 *
 * To run a mutation, you first call `useUpdatePackageHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageHotelMutation, { data, loading, error }] = useUpdatePackageHotelMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      id: // value for 'id'
 *      packageHotelInput: // value for 'packageHotelInput'
 *   },
 * });
 */
export function useUpdatePackageHotelMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageHotelMutationResult, UpdatePackageHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageHotelMutationResult, UpdatePackageHotelMutationVariables>(UpdatePackageHotelDocument, options);
      }
export type UpdatePackageHotelMutationHookResult = ReturnType<typeof useUpdatePackageHotelMutation>;